import { Drawer } from '@sprd/sprd-component-kit/v2';
import { useTranslations } from 'next-intl';
import { SortFilterContent } from '@/components/Filters/FilterContent';

type SortDrawerProps<SortKey extends string = string> = {
  open: boolean;
  onClose: () => void;
  onChange: (sort: SortKey) => void;
  selectedOption: SortKey;
  sortOptions: Record<SortKey, string>;
};

export const SortDrawer = <SortKey extends string = string>({
  open,
  onClose,
  ...rest
}: SortDrawerProps<SortKey>) => {
  const t = useTranslations();

  return (
    <Drawer
      open={open}
      onOpenChange={onClose}
      dismissible
      title={t('filter.sort.sortBy')}
      closeLabel={t('general.close')}
    >
      <SortFilterContent<SortKey> {...rest} className="divide-y divide-neutral-300 pb-16 *:p-4" />
    </Drawer>
  );
};
